import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import styles from '@/components/IntegrationExport/TMSCard/styles';
import { adminSetTmsMailInfoAutobook, SaveApiResMessage } from '@/actions';

export default ({ selectedCompany, DATA }) => {
  const cls = styles();

  const [state, setState] = useState({
    tms_mail_subject: '',
    tms_mail_subject_contain: null,
    tms_mail_address: '',
    plain_mail: false,
    mail_pattern: '',
  });
  const getValue = (primaryKey, fallback = '') => {
    if (DATA?.[primaryKey] !== undefined && DATA?.[primaryKey] !== null) {
      return DATA[primaryKey];
    }
    return fallback;
  };

  const handleSendForm = () => {
    let apiData = {
      tms_mail_subject: state.tms_mail_subject,
      tms_mail_address: state.tms_mail_address,
    };
    if (state.tms_mail_subject_contain) {
      apiData.tms_mail_subject_contain =
        state.tms_mail_subject_contain === 'Contain' ? 1 : 0;
    }
    if (state.plain_mail) {
      apiData.plain_mail = state.plain_mail;
    }
    if (state.mail_pattern) {
      apiData.mail_pattern = state.mail_pattern;
    }
    adminSetTmsMailInfoAutobook(apiData, selectedCompany.value).then((data) => {
      SaveApiResMessage({
        title: data?.data?.messageHeader,
        message: 'Successfully Saved',
        mode: 'success',
      });
    });
  };

  const handleChangeInput = (name, value) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!DATA) return;
    const subjectContain = getValue('tms_mail_subject_contain', null);
    setState({
      tms_mail_subject: getValue('tms_mail_subject', ''),
      tms_mail_address: getValue('tms_mail_address', ''),
      plain_mail: !!getValue('plain_mail', false),
      mail_pattern: getValue('mail_pattern', ''),
      tms_mail_subject_contain:
        subjectContain === 0 || subjectContain === 1
          ? subjectContain === 1
            ? 'Contain'
            : 'Exact'
          : null,
    });
  }, [DATA]);

  return (
    <div>
      <div className={cls.inputContainer}>
        <span>From:</span>
        <TextField
          type="text"
          placeholder="From"
          className={cls.input}
          InputProps={{ disableUnderline: true }}
          inputProps={{ min: 0 }}
          value={state.tms_mail_address}
          onChange={(e) => handleChangeInput('tms_mail_address', e.target.value)}
        />
      </div>
      <div className={cls.inputContainer}>
        <span>Subject:</span>
        <TextField
          type="text"
          placeholder="Subject"
          className={cls.input}
          InputProps={{ disableUnderline: true }}
          inputProps={{ min: 0 }}
          value={state.tms_mail_subject}
          onChange={(e) => handleChangeInput('tms_mail_subject', e.target.value)}
        />
      </div>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={state.tms_mail_subject_contain}
          className={cls.mailCheck}
          onChange={(e) => {
            setState((prev) => ({
              ...prev,
              tms_mail_subject_contain: e.target.value,
            }));
          }}>
          <FormControlLabel value={'Contain'} control={<Radio />} label={'Contain'} />
          <FormControlLabel value={'Exact'} control={<Radio />} label={'Exact'} />
        </RadioGroup>
      </FormControl>
      <div className={cls.btnContainer}>
        <Button onClick={() => handleSendForm()}>Save</Button>
      </div>
    </div>
  );
};
